export * from './en.locale';
export * from './es.locale';
export * from './fr.locale';
